import { ChangeDetectionStrategy, Component, effect, ElementRef, input, signal, viewChild } from '@angular/core';

@Component({
  selector: 'woo-code',
  imports: [],
  templateUrl: './woo-code.component.html',
  styleUrl: './woo-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
})
export class WooCodeComponent {
  title = input<string>('');
  indent = input<'none' | 'small' | 'medium' | 'large'>('none');
  contentChild = viewChild.required<ElementRef<HTMLElement>>('content');
  iconChild = viewChild.required<ElementRef<HTMLElement>>('icon');
  blinking = signal<boolean>(false);

  constructor() {
    effect(() => this.trimEdgeWhitespace(this.contentChild().nativeElement));
  }

  private trimEdgeWhitespace(el: HTMLElement): void {
    while (
      el.firstChild &&
      el.firstChild.nodeType === Node.TEXT_NODE &&
      /^\s*$/.test(el.firstChild.textContent ?? '')
    ) {
      el.removeChild(el.firstChild);
    }
    while (el.lastChild && el.lastChild.nodeType === Node.TEXT_NODE && /^\s*$/.test(el.lastChild.textContent ?? '')) {
      el.removeChild(el.lastChild);
    }
  }

  copy(): void {
    const rawText = this.contentChild().nativeElement.innerText;
    navigator.clipboard.writeText(rawText);
    this.blink();
  }

  blink(): void {
    this.blinking.set(true);
    setTimeout(() => this.blinking.set(false), 300);
  }
}
